import { DATE_FORMAT } from 'constants/date';
import dayjs from 'dayjs';
import { apiSlice } from 'store/api/apiSlice';
import { parseUrlQuery } from 'utils/parsers';
import { peelYamiData } from 'utils/yamiEnvelope';

export const cashierApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSummary: builder.query({
      query: (query) => ({
        url: parseUrlQuery('/api/shops/cashier/summary/', query),
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      transformResponse(res: unknown) {
        const inner = peelYamiData(res) as {
          results?: Array<{ id?: string; summary?: Record<string, unknown> }>;
        };
        const rows = inner?.results ?? [];
        return {
          ...inner,
          results: rows.map((item, index) => {
            const s = item.summary || {};
            const key = `${String(s.username ?? '')}|${String(s.from ?? '')}|${String(s.to ?? '')}`;
            return {
              id: item.id ?? (key !== '||' ? key : `summary-row-${index}`),
              ...s,
            };
          }),
        };
      },
      providesTags: ['CashierSummary'],
    }),
    getRecall: builder.query({
      query: (query) => ({
        url: parseUrlQuery('/api/shops/cashier/recall/', query),
      }),
      transformResponse(res: unknown) {
        const inner = peelYamiData(res) as { results?: Array<{ created_at?: string }> };
        const rows = inner?.results ?? [];
        return {
          ...inner,
          results: rows.map((item) => ({
            ...item,
            created_at: item.created_at
              ? dayjs(item.created_at).format(DATE_FORMAT)
              : '',
          })),
        };
      },
      providesTags: [],
    }),
  }),
});

export const { useGetSummaryQuery, useGetRecallQuery } = cashierApiSlice;
